export default __webpack_public_path__ + "static/media/personal-select.08915a6b.png";